import { render, staticRenderFns } from "./OrderTo.vue?vue&type=template&id=45502f75&scoped=true"
import script from "./OrderTo.vue?vue&type=script&lang=js"
export * from "./OrderTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45502f75",
  null
  
)

export default component.exports